<template>
  <div class="statistics">
    <!-- 左边统计表开始 -->
    <div class="statistics_left">
      <div class="left_head">
        <ul>
          <li>{{$t('projectDetailsV2.totalReport')}}：<span>{{totalWords}}</span></li>
          <li>{{$t('projectDetailsV2.statisticalDimension')}}：<span>{{stateWord}}</span></li>
          <li>{{$t('projectDetailsV2.againfontSize')}}：<span>{{repetitionWords}}</span></li>
        </ul>
        <ul class="ul-right">
          <li>{{$t('projectDetailsV2.statisticalRecord')}}：<el-select v-model="value" @change="selectChanged" clearable :placeholder="$t('projectDetailsV2.pleaseChoose')">
              <el-option
                v-for="item in selectVal"
                :key="item.id"
                :label="item.reportName"
                :value="item.id"
              ></el-option>
            </el-select>
          </li>
          <li>
            <el-button type="primary" @click="getReport">{{$t('projectDetailsV2.createReport')}}</el-button>
          </li>
          <li><el-button @click="downloadFile" type="primary">{{$t('projectDetailsV2.downloadReports')}}</el-button></li>
        </ul>
      </div>

      <div class="left_bottom">
        <div style="min-width: 640px;">
          <el-table
            border
            :data="list"
            header-row-class-name="customHeader"
            :header-cell-style="headerStyle"
          >
            <el-table-column :label="$t('projectDetailsV2.total')" align="center">
              <el-table-column align="center" label-class-name="labelName" :show-overflow-tooltip='true'>
                <template slot-scope="{ row }">
                  {{format(row.countType)}}
                </template>
              </el-table-column>
              <el-table-column :label="$t('projectDetailsV2.perencent')" label-class-name="labelName" prop="percentageNum" align="center">
                
              </el-table-column>
              <el-table-column :label="$t('projectDetailsV2.sentences')" label-class-name="labelName" prop="sentenceNum" align="center">
                
              </el-table-column>
              <el-table-column :label="$t('projectDetailsV2.fontCharacter')" label-class-name="labelName" prop="charNum" align="center">
                
              </el-table-column>
              <el-table-column :label="$t('projectDetailsV2.wordNumbers')" label-class-name="labelName" prop="wordNum" align="center">
                
              </el-table-column>
              <el-table-column :label="$t('projectDetailsV2.spaceNumber')" label-class-name="labelName" prop="spaceNum" align="center">
                
              </el-table-column>
              <el-table-column :label="$t('projectDetailsV2.numberFontsize')" label-class-name="labelName" prop="numberNum" align="center">
                
              </el-table-column>
              <el-table-column :label="$t('projectDetailsV2.Symbol')" label-class-name="labelName" prop="symbolNum" align="center">
                
              </el-table-column>
            </el-table-column>
          </el-table>
          <el-table
            border
            style="width: 100%"
            :data="item"
            :header-cell-style="headerStyle"
            v-for="(item,index) in listAll" :key="index"
          >
            <el-table-column :label="item[0].name" align="center">
              <el-table-column align="center" label-class-name="labelName" :show-overflow-tooltip='true'>
                <template slot-scope="{ row }">
                  {{format(row.countType)}}
                </template>
              </el-table-column>
              <el-table-column :label="$t('projectDetailsV2.perencent')" label-class-name="labelName" prop="percentageNum" align="center">
                
              </el-table-column>
              <el-table-column :label="$t('projectDetailsV2.sentences')" label-class-name="labelName" prop="sentenceNum" align="center">
                
              </el-table-column>
              <el-table-column :label="$t('projectDetailsV2.fontCharacter')" label-class-name="labelName" prop="charNum" align="center">
                
              </el-table-column>
              <el-table-column :label="$t('projectDetailsV2.wordNumbers')" label-class-name="labelName" prop="wordNum" align="center">
                
              </el-table-column>
              <el-table-column :label="$t('projectDetailsV2.spaceNumber')" label-class-name="labelName" prop="spaceNum" align="center">
                
              </el-table-column>
              <el-table-column :label="$t('projectDetailsV2.numberFontsize')" label-class-name="labelName" prop="numberNum" align="center">
                
              </el-table-column>
              <el-table-column :label="$t('projectDetailsV2.Symbol')" label-class-name="labelName" prop="symbolNum" align="center">
                
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 左边统计表借宿 -->

    <!-- 右边统计设置开始 -->
    <div class="statistics_right">
      <div class="right_head">
        <div class="back" @click="handleGoBack">{{$t('projectDetailsV2.goBack')}}</div>
        <div class="head_top">{{$t('projectDetailsV2.statisticalSettings')}}</div>
        <div class="head_bottom">
          <div class="radio_box">
            {{$t('projectDetailsV2.StatisticDimensionss')}}：
            <el-radio
              v-model="radio"
              label="1"
              class="radio_left"
            >{{$t('projectDetailsV2.originalText')}}</el-radio>
            <el-radio
              v-model="radio"
              label="2"
              class="radio_right"
            >{{$t('projectDetailsV2.translateText')}}</el-radio>
          </div>
          <!-- <el-button type="primary" @click="getReport">{{$t('projectDetailsV2.createReport')}}</el-button> -->
        </div>
      </div>
      <div class="right_bottom">
        <!-- 文件 -->
        <div class="project_file">
          <el-table
            height="100%"
            ref="fileTable"
            :data="searchProjectAll"
            :header-cell-style="header2Style"
            @select="fileSelect"
            @select-all="fileSelect"
          >
            <el-table-column>
              <template slot="header">
                <span>{{$t('projectDetailsV2.projectFile')}}</span>
                <span class="numTitle">{{$t('projectDetailsV2.startNumber')}}<span class="num">{{selFileIDList.length}}</span></span>
              </template>
              <el-table-column
                type="selection"
                align="center"
                width="70px"
                label-class-name="labelName"
              >
              </el-table-column>
              <el-table-column prop="name" align="center" label-class-name="labelName">
                <template slot="header" slot-scope="scope">
                  <el-input v-model="searchFileName" @input="searchFileChange" :placeholder="$t('projectDetailsV2.pleaseiputFiles')"></el-input>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
        <!-- 记忆库 -->
        <div class="project_memory">
          <el-table
            height="100%"
            ref="memoryTable"
            :data="memoryAllSearch"
            :header-cell-style="header2Style"
            @select="memorySelect"
            @select-all="memorySelect"
          >
            <el-table-column>
              <template slot="header">
                <span>{{$t('projectDetailsV2.memoryBase')}}</span>
                <span class="numTitle">{{$t('projectDetailsV2.startUsing')}}<span class="num">{{selMemoryIDList.length}}</span></span>
              </template>
              <el-table-column
                type="selection"
                align="center"
                width="70px"
                label-class-name="labelName"
              >
              </el-table-column>
              <el-table-column  prop="name" align="center" label-class-name="labelName">
                <template slot="header" slot-scope="scope">
                  <el-input v-model="searchMemoryName" @input="searchMemoryChange" :placeholder="$t('projectDetailsV2.pleaseiputFiles')"></el-input>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 右边统计设置结束 -->
  </div>
</template>

<script>
import { apiRoot } from "@/services/ajax";
import _ from "lodash";
import {
  projecRegenerating,
  getStatistical,
  getProjectSearch,
  getMemorySearch,
  getFormList,
  getAllForm,
  recordExportaAnalysisReport
} from "@/services/projectStatistics.js";

export default {
  name: 'statistics',
  props: {
    createObj: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  data () {
    return {
      totalWords: 0,
      repetitionWords: 0,
      value: '',
      selectVal: [],
      headerStyle: {
        background: '#e4edfc',
        color: '#566087',
        fontSize: '16px',
        borderColor: '#F2F2F2',
        padding: '9px 0',
      },
      header2Style: {
        background: '#e4edfc',
        color: '#566087',
        fontSize: '16px',
        borderColor: '#F2F2F2',
        padding: '9px 10px',
      },
      // projectNum: 0,
      memoryNum: 0,

      searchFileName: '',
      selFileIDList: [], //项目文件选中id
      selFileList: [],

      searchMemoryName: '',
      selMemoryIDList: [],
      selMemoryList: [],

      companyCode: "",
      id: "",
      radio: "1",
      searchProjectAll: [], //全部文件
      memoryAllSearch: [], //记忆库搜索所有文件
      listAll: [],
      stateWord: this.$t('projectDetailsV2.no'),
      totalReportId: "",
      list: [],
    }
  },
  mounted () {
    this.id = this.$route.query.id;
    this.getStat();
    this.getProject();
    this.getMemory();
    this.list = [
      {"id":null,"companyCode":null,"projectId":null,"fileId":null,"name":null,"reportId":null,"countType":1,"percentageNum":'',"sentenceNum":'',"charNum":'',"wordNum":'',"spaceNum":'',"numberNum":'',"symbolNum":'',"fileType":0,"status":0,"creatorId":0,"updaterId":0,"createTime":0,"updateTime":0},
      {"id":null,"companyCode":null,"projectId":null,"fileId":null,"name":null,"reportId":null,"countType":2,"percentageNum":'',"sentenceNum":'',"charNum":'',"wordNum":'',"spaceNum":'',"numberNum":'',"symbolNum":'',"fileType":0,"status":0,"creatorId":0,"updaterId":0,"createTime":0,"updateTime":0},
      {"id":null,"companyCode":null,"projectId":null,"fileId":null,"name":null,"reportId":null,"countType":3,"percentageNum":'',"sentenceNum":'',"charNum":'',"wordNum":'',"spaceNum":'',"numberNum":'',"symbolNum":'',"fileType":0,"status":0,"creatorId":0,"updaterId":0,"createTime":0,"updateTime":0},
      {"id":null,"companyCode":null,"projectId":null,"fileId":null,"name":null,"reportId":null,"countType":4,"percentageNum":'',"sentenceNum":'',"charNum":'',"wordNum":'',"spaceNum":'',"numberNum":'',"symbolNum":'',"fileType":0,"status":0,"creatorId":0,"updaterId":0,"createTime":0,"updateTime":0},
      {"id":null,"companyCode":null,"projectId":null,"fileId":null,"name":null,"reportId":null,"countType":5,"percentageNum":'',"sentenceNum":'',"charNum":'',"wordNum":'',"spaceNum":'',"numberNum":'',"symbolNum":'',"fileType":0,"status":0,"creatorId":0,"updaterId":0,"createTime":0,"updateTime":0},
      {"id":null,"companyCode":null,"projectId":null,"fileId":null,"name":null,"reportId":null,"countType":6,"percentageNum":'',"sentenceNum":'',"charNum":'',"wordNum":'',"spaceNum":'',"numberNum":'',"symbolNum":'',"fileType":0,"status":0,"creatorId":0,"updaterId":0,"createTime":0,"updateTime":0},
      {"id":null,"companyCode":null,"projectId":null,"fileId":null,"name":null,"reportId":null,"countType":7,"percentageNum":'',"sentenceNum":'',"charNum":'',"wordNum":'',"spaceNum":'',"numberNum":'',"symbolNum":'',"fileType":0,"status":0,"creatorId":0,"updaterId":0,"createTime":0,"updateTime":0},
      {"id":null,"companyCode":null,"projectId":null,"fileId":null,"name":null,"reportId":null,"countType":8,"percentageNum":'',"sentenceNum":'',"charNum":'',"wordNum":'',"spaceNum":'',"numberNum":'',"symbolNum":'',"fileType":0,"status":0,"creatorId":0,"updaterId":0,"createTime":0,"updateTime":0},
      {"id":null,"companyCode":null,"projectId":null,"fileId":null,"name":null,"reportId":null,"countType":9,"percentageNum":'',"sentenceNum":'',"charNum":'',"wordNum":'',"spaceNum":'',"numberNum":'',"symbolNum":'',"fileType":0,"status":0,"creatorId":0,"updaterId":0,"createTime":0,"updateTime":0}
    ];
  },
  methods: {
    handleGoBack () {
      this.$router.push({
        name: 'ProjectDetail',
        query: { id: this.$route.query.id }
      })
    },
    //获取项目文件
    async getProject() {
      const res = await getProjectSearch({
        projectId: this.id,
        name: this.searchFileName
      });
      if (res.success) {
        this.searchProjectAll = res.result;
        this.$nextTick(() => {
          this.searchProjectAll.forEach(item => {
            if (this.selFileIDList.includes(item.id)) {
              this.$refs.fileTable.toggleRowSelection(item, true);
            }
          });
        });
      }
    },
    //获取记忆库文件
    async getMemory() {
      const res = await getMemorySearch({
        projectId: this.id,
        name: this.searchMemoryName,
      });
      if (res.success) {
        this.memoryAllSearch = res.result;
        this.$nextTick(() => {
          this.memoryAllSearch.forEach(item => {
            if (this.selMemoryIDList.includes(item.id)) {
              this.$refs.memoryTable.toggleRowSelection(item, true);
            }
          });
        });
      }
    },
    fileSelect (selection) {
      let idList = this.searchProjectAll.map(item => item.id);
      this.selFileList = this.selFileList.filter(item => !idList.includes(item.id));
      this.selFileList.push(...selection);
      this.selFileIDList = this.selFileList.map(item => item.id);
    },
    memorySelect (selection) {
      let idList = this.memoryAllSearch.map(item => item.id);
      this.selMemoryList = this.selMemoryList.filter(item => !idList.includes(item.id));
      this.selMemoryList.push(...selection);
      this.selMemoryIDList = this.selMemoryList.map(item => item.id);
    },
    searchFileChange: _.throttle(function () {
      this.getProject();
    }, 2000),
    searchMemoryChange: _.throttle(function () {
      this.getMemory();
    }, 2000),
    //统计记录
    async getStat() {
      let params = {
        projectId: this.id
      };
      const res = await getStatistical(params);
      if (res.success) {
        this.selectVal = res.result;
      }
      // else {
      //   this.$message.closeAll();
      //   this.$message.error(res.errorDesc);
      // }
    },
    async downloadFile() {
      if (this.value === '') {
        this.$message.closeAll();
        this.$message({
          message: this.$t('projectDetailsV2.pleaseChoose'),
          type: 'warning'
        });
        return;
      }
      let params = {
        projectId: this.id,
        reportId: this.value
      };
      const res = await recordExportaAnalysisReport(params);
      if (res.success && res.status === 200) {
        let param = {
          name: "统计报告.xlsx",
          path: res.result
        };
        let paths = `/common/downloadFile?fileName=${param.name}&filePath=${param.path}`;
        window.location.href = apiRoot(paths);
      }
    },
    //统计记录改变
    selectChanged() {
      if (this.value === '') {
        this.list = [];
        this.listAll = [];
        this.totalWords = 0;
        this.repetitionWords = 0;
        this.stateWord = this.$t('projectDetailsV2.no');
        this.list = [
          {"id":null,"companyCode":null,"projectId":null,"fileId":null,"name":null,"reportId":null,"countType":1,"percentageNum":'',"sentenceNum":'',"charNum":'',"wordNum":'',"spaceNum":'',"numberNum":'',"symbolNum":'',"fileType":0,"status":0,"creatorId":0,"updaterId":0,"createTime":0,"updateTime":0},
          {"id":null,"companyCode":null,"projectId":null,"fileId":null,"name":null,"reportId":null,"countType":2,"percentageNum":'',"sentenceNum":'',"charNum":'',"wordNum":'',"spaceNum":'',"numberNum":'',"symbolNum":'',"fileType":0,"status":0,"creatorId":0,"updaterId":0,"createTime":0,"updateTime":0},
          {"id":null,"companyCode":null,"projectId":null,"fileId":null,"name":null,"reportId":null,"countType":3,"percentageNum":'',"sentenceNum":'',"charNum":'',"wordNum":'',"spaceNum":'',"numberNum":'',"symbolNum":'',"fileType":0,"status":0,"creatorId":0,"updaterId":0,"createTime":0,"updateTime":0},
          {"id":null,"companyCode":null,"projectId":null,"fileId":null,"name":null,"reportId":null,"countType":4,"percentageNum":'',"sentenceNum":'',"charNum":'',"wordNum":'',"spaceNum":'',"numberNum":'',"symbolNum":'',"fileType":0,"status":0,"creatorId":0,"updaterId":0,"createTime":0,"updateTime":0},
          {"id":null,"companyCode":null,"projectId":null,"fileId":null,"name":null,"reportId":null,"countType":5,"percentageNum":'',"sentenceNum":'',"charNum":'',"wordNum":'',"spaceNum":'',"numberNum":'',"symbolNum":'',"fileType":0,"status":0,"creatorId":0,"updaterId":0,"createTime":0,"updateTime":0},
          {"id":null,"companyCode":null,"projectId":null,"fileId":null,"name":null,"reportId":null,"countType":6,"percentageNum":'',"sentenceNum":'',"charNum":'',"wordNum":'',"spaceNum":'',"numberNum":'',"symbolNum":'',"fileType":0,"status":0,"creatorId":0,"updaterId":0,"createTime":0,"updateTime":0},
          {"id":null,"companyCode":null,"projectId":null,"fileId":null,"name":null,"reportId":null,"countType":7,"percentageNum":'',"sentenceNum":'',"charNum":'',"wordNum":'',"spaceNum":'',"numberNum":'',"symbolNum":'',"fileType":0,"status":0,"creatorId":0,"updaterId":0,"createTime":0,"updateTime":0},
          {"id":null,"companyCode":null,"projectId":null,"fileId":null,"name":null,"reportId":null,"countType":8,"percentageNum":'',"sentenceNum":'',"charNum":'',"wordNum":'',"spaceNum":'',"numberNum":'',"symbolNum":'',"fileType":0,"status":0,"creatorId":0,"updaterId":0,"createTime":0,"updateTime":0},
          {"id":null,"companyCode":null,"projectId":null,"fileId":null,"name":null,"reportId":null,"countType":9,"percentageNum":'',"sentenceNum":'',"charNum":'',"wordNum":'',"spaceNum":'',"numberNum":'',"symbolNum":'',"fileType":0,"status":0,"creatorId":0,"updaterId":0,"createTime":0,"updateTime":0}
        ];
        return;
      }
      this.getAllFormList();
      this.getList();
    },
    // 单个文件统计记录
    async getList() {
      let params = {
        projectId: this.id,
        reportId: this.value
      };
      const res = await getFormList(params);
      if (res.resultCode == 1 && res.success) {
        res.result.forEach(item => {
          item.sort((prop => {
              return (a, b) => {
                  let v1 = a[prop];
                  let v2 = b[prop];
                  return v1 - v2;
              }
          })('countType'));
        });
        this.stateWord = res.result[0][0].fileType == 1
        ? this.$t("projectDetailsV2.originalTextss")
        : this.$t("projectDetailsV2.translateTexts");
        this.listAll = res.result;
      }
    },
    // 获取总计列表
    async getAllFormList() {
      let params = {
        projectId: this.id,
        reportId: this.value
      };
      const res = await getAllForm(params);
      if (res.success) {
        res.result.forEach(item => {
          if (item.countType === 9) {
            this.totalWords = item.wordNum;
          }
          if (item.countType === 7) {
            this.repetitionWords = item.wordNum;
          }
        });
        res.result.sort((prop => {
            return (a, b) => {
                let v1 = a[prop];
                let v2 = b[prop];
                return v1 - v2;
            }
        })('countType'));
        console.log(JSON.stringify(res.result));
        this.list = res.result;
      }
    },
    format (type) {
      switch (type) {
        case 1:
          return this.$t("projectDetailsV2.newWordsss");
        case 2:
          return this.$t("projectDetailsV2.fiftyss");
        case 3:
          return this.$t("projectDetailsV2.seventyFivess");
        case 4:
          return this.$t("projectDetailsV2.eightyFivess");
        case 5:
          return this.$t("projectDetailsV2.ninetyFivess");
        case 6:
          return this.$t("projectDetailsV2.oneHundredss");
        case 7:
          return this.$t("projectDetailsV2.internalRepeatss");
        case 8:
          return this.$t("projectDetailsV2.duplicateFilesss");
        case 9:
          return this.$t("projectDetailsV2.totals");
      }
    },
    //生成报告
    async getReport() {
      let self = this;
      let params = {
        fileType: Number(this.radio),
        memoryIdList: this.selMemoryIDList,
        projectId: this.id,
        transFileIds: this.selFileIDList
      };
      // if((params.memoryIdList.length == 0) && (params.transFileIds.length == 0)){
      //     this.$message.closeAll();
      //     this.$message.warning(this.$t('projectDetailsV2.selFileAndMemoryTip'));
      //     return;
      // } else 
      if (params.transFileIds.length == 0) {
        this.$message.closeAll();
        this.$message.warning(this.$t('projectDetailsV2.selFileTip'));
        return;
      }
      //  else if (params.memoryIdList.length == 0) {
      //   this.$message.closeAll();
      //   this.$message.warning(this.$t('projectDetailsV2.selMemoryTip'));
      //   return;
      // }
      const res = await projecRegenerating(params);
      if (res.success && res.status == 200) {
        // 获取最新报告下拉列表
        await this.getStat();
        // 默认选中最新
        this.value = this.selectVal[this.selectVal.length - 1].id;
        this.getAllFormList();
        this.getList();
      } else {
          self.$message.closeAll();
          self.$message.error(res.errorDesc);
      }
    },
  }
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>
